import React from 'react';
import SVGIcon from '../../assets/images/svg/SVGIcon';
import { DropFileDiv } from './styles';

/**
 * DropBox renders a file drop zone overlay with customizable dimensions and positioning
 * @param {number} editorHeight - Height of the drop box in pixels (default: 98)
 * @param {number} applyDropBoxTopSpacing - Top spacing offset for the drop box in pixels
 * @param {string} applyWidth - Custom width for the drop box (e.g., '100%', '-webkit-fill-available') (default: '100%')
 */
interface DropBoxProps {
  editorHeight?: number;
  applyDropBoxTopSpacing?: number;
  applyWidth?: string;
}

const DropBox: React.FC<DropBoxProps> = ({ editorHeight = 98, applyDropBoxTopSpacing, applyWidth }) => {
  return (
    <>
      <DropFileDiv editorHeight={editorHeight} applyDropBoxTopSpacing={applyDropBoxTopSpacing} applyWidth={applyWidth}>
        <SVGIcon name='drop-file-icon' width='36' height='36' viewBox='0 0 36 36' />
        <span>Drop your files here</span>
      </DropFileDiv>
    </>
  );
};

export default DropBox;
